import React from 'react';
import { iconsPath, imagePath } from '../imagePath';


const ARFeatureGrid = () => {
  return (
    <>
      {/* Mobile Layout - Stacked to match the image exactly */}
      <div className="md:hidden min-h-screen bg-[#121316] text-white px-6 py-8 flex flex-col items-center">
        {/* Header */}
        <div className="mb-6 text-left w-full max-w-md">
          <h1 className="text-3xl font-semibold mb-2">Designed for Users</h1>
          <p className="text-sm text-[#FFFFFF9E] font-normal">
            Secure, intelligent, and built with safety & ethics in mind.
          </p>
        </div>

        {/* AR Glasses with loading spinner */}
        <div className="relative mb-8">
          <img src={imagePath?.UserGlass} alt="AR Glasses" className="w-72" />
        </div>

        {/* Feature Cards - Stacked */}
        <div className="w-full max-w-md space-y-4">
          {/* Card 1 */}
          <div className="bg-[#212121] rounded-[10px] p-4 flex items-start gap-3 border border-[#424242]">
            <div className="bg-[#D9232A1F] h-12 w-12 rounded-[10px] flex items-center justify-center shrink-0">
              <img
                className="h-6 w-6"
                src={iconsPath?.MultipleTracking}
                alt=""
              />
            </div>
            <div>
              <h3 className="font-semibold font-jakarta text-[#D8D8D8] text-base mb-2">
                Multiple Tracking Mechanisms
              </h3>
              <ul className="text-sm space-y-1 font-normal text-[#8E8E8E] list-disc pl-4">
                <li>Object tracking</li>
                <li>Image tracking</li>
                <li>Location-based tracking</li>
                <li>Other spatial anchors</li>
              </ul>
            </div>
          </div>

          {/* Card 2 */}
          <div className="bg-[#212121] rounded-[10px] p-4 flex items-start gap-3 border border-[#424242]">
            <div className="bg-[#D9232A1F] h-12 w-12 rounded-[10px] flex items-center justify-center shrink-0">
              <img
                className="h-6 w-6"
                src={iconsPath?.IntellegenceAcross}
                alt=""
              />
            </div>
            <div>
              <h3 className="font-semibold font-jakarta text-[#D8D8D8] text-base mb-2">
                Intelligence across physical and digital worlds
              </h3>

              <ul className="text-sm space-y-1 font-normal text-[#8E8E8E] list-disc pl-4">
                <li>Smart interactions with digital and real-world objects</li>
                <li>Context-aware prompts and guidance</li>
              </ul>
            </div>
          </div>

          {/* Card 3 */}
          <div className="bg-[#212121] rounded-[10px] p-4 flex items-start gap-3 border border-[#424242]">
            <div className="bg-[#D9232A1F] h-12 w-12 rounded-[10px] flex items-center justify-center shrink-0">
              <img
                className="h-6 w-6"
                src={iconsPath?.SituationalAwearness}
                alt=""
              />
            </div>
            <div>
              <h3 className="font-semibold font-jakarta text-[#D8D8D8] text-base mb-2">
                Situational awareness & safety
              </h3>
              <ul className="text-sm space-y-1 font-normal text-[#8E8E8E] list-disc pl-4">
                <li>Spatial understanding to avoid unsafe interactions</li>
                <li>System-level checks and boundaries</li>
              </ul>
            </div>
          </div>

          {/* Card 4 */}
          <div className="bg-[#212121] rounded-[10px] p-4 flex items-start gap-3 border border-[#424242]">
            <div className="bg-[#D9232A1F] h-12 w-12 rounded-[10px] flex items-center justify-center shrink-0">
              <img
                className="h-6 w-6"
                src={iconsPath?.EthicalExperience}
                alt=""
              />
            </div>
            <div>
              <h3 className="font-semibold font-jakarta text-[#D8D8D8] text-base mb-2">
                Usage policies for ethical, pleasant experiences
              </h3>
              <ul className="text-sm space-y-1 font-normal text-[#8E8E8E] list-disc pl-4">
                <li>Guardrails for how, when, and where content appears</li>
                <li>
                  Controls aligned with moral, ethical, and organizational
                  standards
                </li>
              </ul>
            </div>
          </div>
        </div>

        {/* Red CTA Button */}
        <button className="mt-8 bg-[#EE2B2A]  text-white font-bold w-full py-3 px-8 rounded-[10px] flex items-center justify-center gap-3 text-base">
          Let's Talk <img className='h-5 w-5' src={iconsPath?.LetsTalkArrow} alt="" />
        </button>
      </div>

      {/* Desktop Layout - Original Grid (unchanged) */}
      <div className="hidden md:block min-h-screen flex items-center justify-center p-4">
        <div className="w-full max-w-[1400px] mx-auto py-16">
          <div className="flex flex-col gap-3 mb-8">
            <h1 className="text-white font-light text-4xl">
              Designed for Users
            </h1>
            <p className="text-[#CFCCCC] font-normal">
              For end users, SpatialOS is about making immersive experiences
              feel natural, safe, and seamless. SpatialOS, applications can
              offer:
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 auto-rows-fr">
            {/* CARD 1: Wide Top Left */}
            <div className="lg:col-span-2">
              <FeatureCard
                viewBox="0 0 1039 521"
                path="M519.718 0.00211979C674.546 0.00211979 829.374 -0.0058377 984.202 0.00908259C1011.1 0.0120667 1032.18 14.9503 1037.99 38.1762C1038.73 41.1234 1038.94 44.2309 1038.94 47.2646C1038.99 169.135 1039.04 291.004 1038.94 412.874C1038.92 439.116 1014.87 459.379 984.005 459.405C903.687 459.474 823.369 459.365 743.052 459.524C736.139 459.538 729.058 460.408 722.36 461.946C710.926 464.573 701.976 470.906 694.956 479.351C689.81 485.541 684.741 491.79 679.851 498.145C668.353 513.086 652.429 520.131 632.347 520.121C569.655 520.09 506.963 520.101 444.27 520.103C315.08 520.106 185.891 520.116 56.701 520.119C22.5834 520.119 0.0204673 500.087 0.0160356 469.646C-0.00833889 329.8 -0.00396154 189.954 0.0226288 50.1094C0.0281684 20.2579 22.6422 0.00609854 55.838 0.00510385C210.465 0.00112511 365.091 0.000130418 519.718 0.00211979Z"
                title="Multiple tracking mechanisms"
                items={[
                  'Object tracking',
                  'Image tracking',
                  'Location-based tracking',
                  'Other spatial anchors',
                ]}
              />
            </div>

            {/* CARD 2: Top Right */}
            <div className="col-span-1">
              <FeatureCard
                viewBox="0 0 505 521"
                path="M504.587 257.895C504.587 328.898 504.572 399.901 504.593 470.905C504.602 499.247 481.756 520.125 450.209 520.141C318.613 520.208 187.016 520.208 55.4207 520.159C27.7602 520.148 7.53043 506.101 1.08671 482.642C0.236926 479.547 0.0452441 476.241 0.0441361 473.033C-0.00128901 331.207 -0.0267714 189.38 0.0441361 47.5532C0.0574313 21.1621 23.1257 0.25583 52.6077 0.144425C106.487 -0.0584912 160.369 -0.0356134 214.249 0.138457C232.53 0.198138 246.822 7.80848 257.793 20.6827C264.861 28.9764 273.168 35.982 284.403 39.2495C290.418 40.9982 296.842 42.4047 303.113 42.5141C325.539 42.903 347.98 42.8851 370.41 42.6026C386.876 42.3957 400.668 36.4127 411.42 25.1677C419.356 16.8671 426.581 8.10192 438.453 3.5751C468.587 -7.91751 503.031 11.2302 504.503 40.5715C504.61 42.725 504.578 44.8844 504.578 47.0419C504.581 117.326 504.579 187.61 504.587 257.895Z"
                title="Intelligence across physical and digital worlds"
                items={[
                  'Smart interactions with digital and real-world objects',
                  'Context-aware prompts and guidance',
                ]}
              />
            </div>

            {/* CARD 3: Bottom Left with Circle */}
            <div className="col-span-1 md:order-1 lg:order-none">
              <FeatureCard
                viewBox="0 0 505 521"
                path="M0.0168221 259.951C0.0168221 189.72 -0.0374346 119.489 0.0489332 49.258C0.0766151 27.2555 12.621 10.5884 35.0677 3.12075C40.7592 1.22798 47.1548 0.22294 53.2315 0.20604C123.282 0.00821359 193.336 -0.140902 263.385 0.216975C283.973 0.32235 300.011 9.1112 309.507 25.6998C327.044 56.335 343.799 87.3301 361.281 117.991C371.423 135.779 387.992 145.177 410.441 145.543C423.446 145.754 436.465 145.818 449.468 145.555C480.363 144.928 504.677 167.495 504.506 194.751C503.933 286.353 503.844 377.964 504.592 469.564C504.814 496.828 481.792 520.202 447.72 520.04C351.651 519.583 255.579 519.863 159.508 519.853C124.882 519.849 90.2567 519.888 55.6321 519.831C22.6906 519.776 0.079937 499.622 0.0467186 470.105C-0.0318982 400.054 0.0201439 330.002 0.0168221 259.951Z"
                title="Situational awareness & safety"
                items={[
                  'Spatial understanding to avoid unsafe interactions',
                  'System-level checks and boundaries',
                ]}
                showCircle={true}
              />
            </div>

            {/* CARD 4: Red CTA Center */}
            <div className="bg-[#EE2B2A] rounded-[20px] p-10 flex flex-col justify-between items-start min-h-[350px] md:order-2 lg:order-none overflow-hidden">
              <h2 className="text-4xl font-normal flex items-center gap-3 text-white mb-4">
                Lets Talk{' '}
                <img className="h-5 w-5" src={iconsPath?.LetsTalk} alt="" />
              </h2>
              <div className="w-full flex justify-end ml-11">
                <img
                  src={imagePath?.UserGlass}
                  alt="User with AR glasses"
                  className="max-w-[350px] md:max-w-[360px]"
                />
              </div>
            </div>

            {/* CARD 5: Bottom Right */}
            <div className="col-span-1 md:order-3 lg:order-none">
              <FeatureCard
                viewBox="0 0 505 521"
                path="M0.0168221 259.951C0.0168221 189.72 -0.0374346 119.489 0.0489332 49.258C0.0766151 27.2555 12.621 10.5884 35.0677 3.12075C40.7592 1.22798 47.1548 0.22294 53.2315 0.20604C123.282 0.00821359 193.336 -0.140902 263.385 0.216975C283.973 0.32235 300.011 9.1112 309.507 25.6998C327.044 56.335 343.799 87.3301 361.281 117.991C371.423 135.779 387.992 145.177 410.441 145.543C423.446 145.754 436.465 145.818 449.468 145.555C480.363 144.928 504.677 167.495 504.506 194.751C503.933 286.353 503.844 377.964 504.592 469.564C504.814 496.828 481.792 520.202 447.72 520.04C351.651 519.583 255.579 519.863 159.508 519.853C124.882 519.849 90.2567 519.888 55.6321 519.831C22.6906 519.776 0.079937 499.622 0.0467186 470.105C-0.0318982 400.054 0.0201439 330.002 0.0168221 259.951Z"
                title="Usage policies for ethical, pleasant experiences"
                items={[
                  'Guardrails for how, when, and where content appears',
                  'Controls aligned with moral, ethical, and organizational standards',
                ]}
                showCircle={true}
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

const FeatureCard = ({ viewBox, path, title, items, showCircle = false }) => (
  <div className="relative w-full h-full min-h-[150px] md:min-h-[200px] lg:min-h-[420px] flex items-end justify-start pt-8 pb-12 md:pt-10 md:pb-8 px-2 md:px-4 lg:px-3">
    {/* SVG Background Layer */}
    <div className="absolute inset-0 z-0">
      <svg
        className="w-full h-full"
        viewBox={viewBox}
        fill="none"
        preserveAspectRatio="none"
      >
        <path d={path} fill="#F0F0F0" />
      </svg>
    </div>

    {/* White Circle - Positioned absolutely to maintain perfect circle */}
    {showCircle && (
      <div className="absolute top-6 right-6 md:top-0 md:right-8 lg:top-0 lg:right-0 z-[5] w-8 h-8 md:w-10 md:h-10 lg:w-12 lg:h-12 bg-[#F0F0F0] rounded-full"></div>
    )}

    {/* Content Layer */}
    <div className="relative z-10 flex flex-col items-start text-left w-full px-6">
      <h2 className="text-3xl md:text-md lg:text-2xl font-bold text-[#080808] mb-6 leading-[1.2] max-w-[60%] md:max-w-[90%]">
        {title}
      </h2>

      <ul className="list-disc list-outside ml-6 space-y-1 md:space-y-2 lg:space-y-3">
        {items.map((item, idx) => (
          <li
            key={idx}
            className="text-[#080808] text-2xl md:text-base lg:text-lg font-normal leading-relaxed"
          >
            {item}
          </li>
        ))}
      </ul>
    </div>
  </div>
);



export default ARFeatureGrid;
